import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://akbogyvdmldcfhsvivxs.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFrYm9neXZkbWxkY2Zoc3ZpdnhzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYxMzMxMTMsImV4cCI6MjA3MTcwOTExM30.T51TOrtuG0EGKlOxPJNPr9J1tN9fsT4npYRGPAawcsE';

// const SUPABASE_URL = 'https://haovwvgguawxwzdvecio.supabase.co'
// const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imhhb3Z3dmdndWF3eHd6ZHZlY2lvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ1NjQ2MzUsImV4cCI6MjA3MDE0MDYzNX0.eJH3g32-joyrP2I7gNZ6gVPm5dI30Ue1hi9aatm5gdM'

if(SUPABASE_URL == 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY == '<ANON_KEY>'){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})